/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { SimulationStatus } from './SimulationStatus';
import {
    SimulationStatusFromJSON,
    SimulationStatusFromJSONTyped,
    SimulationStatusToJSON,
    SimulationStatusToJSONTyped,
} from './SimulationStatus';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';
import type { VersionActionType } from './VersionActionType';
import {
    VersionActionTypeFromJSON,
    VersionActionTypeFromJSONTyped,
    VersionActionTypeToJSON,
    VersionActionTypeToJSONTyped,
} from './VersionActionType';

/**
 * 
 * @export
 * @interface VersionEntryDto
 */
export interface VersionEntryDto {
    /**
     * 
     * @type {Date}
     * @memberof VersionEntryDto
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof VersionEntryDto
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof VersionEntryDto
     */
    id: number;
    /**
     * 
     * @type {VersionActionType}
     * @memberof VersionEntryDto
     */
    actionType: VersionActionType;
    /**
     * 
     * @type {UserDto}
     * @memberof VersionEntryDto
     */
    createdBy: UserDto;
    /**
     * 
     * @type {SimulationStatus}
     * @memberof VersionEntryDto
     */
    simulationStatus: SimulationStatus;
    /**
     * 
     * @type {UserDto}
     * @memberof VersionEntryDto
     */
    simulationAssignedTo: UserDto;
    /**
     * 
     * @type {SimulationStatus}
     * @memberof VersionEntryDto
     */
    previousStatus?: SimulationStatus;
    /**
     * 
     * @type {UserDto}
     * @memberof VersionEntryDto
     */
    previousAssignedTo?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof VersionEntryDto
     */
    message?: string | null;
}



/**
 * Check if a given object implements the VersionEntryDto interface.
 */
export function instanceOfVersionEntryDto(value: object): value is VersionEntryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('simulationStatus' in value) || value['simulationStatus'] === undefined) return false;
    if (!('simulationAssignedTo' in value) || value['simulationAssignedTo'] === undefined) return false;
    return true;
}

export function VersionEntryDtoFromJSON(json: any): VersionEntryDto {
    return VersionEntryDtoFromJSONTyped(json, false);
}

export function VersionEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionEntryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'id': json['id'],
        'actionType': VersionActionTypeFromJSON(json['actionType']),
        'createdBy': UserDtoFromJSON(json['createdBy']),
        'simulationStatus': SimulationStatusFromJSON(json['simulationStatus']),
        'simulationAssignedTo': UserDtoFromJSON(json['simulationAssignedTo']),
        'previousStatus': json['previousStatus'] == null ? undefined : SimulationStatusFromJSON(json['previousStatus']),
        'previousAssignedTo': json['previousAssignedTo'] == null ? undefined : UserDtoFromJSON(json['previousAssignedTo']),
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function VersionEntryDtoToJSON(json: any): VersionEntryDto {
    return VersionEntryDtoToJSONTyped(json, false);
}

export function VersionEntryDtoToJSONTyped(value?: VersionEntryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
        'id': value['id'],
        'actionType': VersionActionTypeToJSON(value['actionType']),
        'createdBy': UserDtoToJSON(value['createdBy']),
        'simulationStatus': SimulationStatusToJSON(value['simulationStatus']),
        'simulationAssignedTo': UserDtoToJSON(value['simulationAssignedTo']),
        'previousStatus': SimulationStatusToJSON(value['previousStatus']),
        'previousAssignedTo': UserDtoToJSON(value['previousAssignedTo']),
        'message': value['message'],
    };
}

